module.exports = "/_next/static/images/slide1-1471058eb5fec6122ec8409d16659916.webp";